import { isString } from './validate';

const _toString = Object.prototype.toString;

/**
 * 获取变量类型
 *
 * @param {any} val
 * @returns {string | IType} 该变量类型
 */
export function getType(val: any, needMethods = false) {
  const array = _toString.call(val).split(' ');
  const value = array[1].slice(0, array[1].length - 1);
  if (needMethods) {
    return {
      equal: (type: any) => equal(value, type),
      value
    };
  }
  return value;
}

/**
 * 比较是否是同个类型
 *
 * @param {string} val
 * @param {string} type
 * @returns {boolean}
 */
export function equal(val: any, type: any): boolean {
  if (!isString(val) || !isString(type)) {
    throw new Error('val/type must be string');
  }
  return val.toLowerCase() === type.toLowerCase();
}
